import React from 'react';
import i18n from '../I18N/I18n.js'; 
import { useState } from "react";

const ProductDetailsComponent = ({ userNft, campos, idProducto, campoFecha, campoA1, pestaniaDetails, changePestaniaDetails, modificaciones, agregarModificacion}) => {
    
  const fechaA1 = new Date(userNft.campoA1);
  const fecha0 = new Date(userNft.campo0);
  const fechaCampoFecha = new Date(userNft.campoFecha);

    const [modalAbierto, setModalAbierto] = useState(false);
    const [foto, setFoto] = useState(null);
    const [descripcion, setDescripcion] = useState("");
    const [precio, setPrecio] = useState("");

    const abrirModal = () => setModalAbierto(true);
    const cerrarModal = () => setModalAbierto(false);
    
    const camposOpcionales = campos
    .filter(campo =>
        campo.orden.match(/^CAMPO\d+$/) && campo.orden !== "CAMPO1A" // Excluye CAMPO1A
    )
    .sort((a, b) => {
        // Extrae los números de los strings "CAMPOX"
        const numA = parseInt(a.orden.replace('CAMPO', ''), 10);
        const numB = parseInt(b.orden.replace('CAMPO', ''), 10);
        return numA - numB; // Ordena de menor a mayor
    });

    const manejarCambioFoto = (e) => {
        setFoto(e.target.files[0]);
    };

    const manejarCambioDescripcion = (e) => setDescripcion(e.target.value);
    const manejarCambioPrecio = (e) => setPrecio(e.target.value);


    const [valores, setValores] = useState(
        camposOpcionales.reduce((acc, campo) => {
          const index = parseInt(campo.orden.replace("CAMPO", ""));
          acc[`campo${index}`] = userNft[`campo${index}`] || "";
          return acc;
        }, {})
      );
    
      // Maneja el cambio en los inputs
      const manejarCambio = (index, valor) => {
        setValores((prevValores) => ({
          ...prevValores,
          [`campo${index}`]: valor,
        }));
      };

      const enviarModificacion = () => {
        agregarModificacion(
            valores["campo0"], valores["campo1"], valores["campo2"], valores["campo3"],
            valores["campo4"], valores["campo5"], valores["campo6"], valores["campo7"],
            valores["campo8"], valores["campo9"], valores["campo10"], valores["campo11"],
            valores["campo12"], valores["campo13"], valores["campo14"], valores["campo15"],
            foto, descripcion, precio
        );
        cerrarModal(); // Cierra el modal después de guardar
    };
    
    

    return (
        <>
  
                                  <div className="tabs">
                                          <button
                                          className={pestaniaDetails === 1 ? 'active-tab' : 'tab'}
                                          onClick={() => changePestaniaDetails(1)}
                                          >
                                          {i18n.t('detalles')}
                                          </button>
                                          <button
                                          className={pestaniaDetails === 2 ? 'active-tab' : 'tab'}
                                          onClick={() => changePestaniaDetails(2)}
                                          >
                                          {i18n.t('modificaciones')}
                                          </button>
                                          
                                    </div>
  
  
                                      {pestaniaDetails === 1 && (
                                           <div className="certificateProductData_card_1">
                                           <p className="titleCard_16">{i18n.t('ProductDetails')}</p>
                                           <table className="productDetails_table_16">
                                                <tbody>
                                                <tr>
                                                    <th className="details_th_16">{i18n.t(campos.filter(campo => campo.orden == "IDPRODUCTO")[0].nombreCampo)}</th>
                                                    <td className="details_td_16">{userNft.idProducto}</td>
                                                </tr>
                                                                                <tr>
                                                    <th className="details_th_16">{i18n.t(campos.filter(campo => campo.orden == "FECHA")[0].nombreCampo)}</th>
                                                    <td className="details_td_16">{fechaCampoFecha.toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <th className="details_th_16">
                                                    {i18n.t(campos.filter(campo => campo.orden == "CAMPO1A")[0].nombreCampo)}
                                                    </th>
                                                    <td className="details_td_16">{fechaA1.toLocaleString()}</td>
                                                </tr>  
                                                    {camposOpcionales.some(campo => campo.orden === "CAMPO0" && campo.mostrar === "true") && (
                                                        <tr key="campo0">
                                                            <th className="details_th_16">{i18n.t(camposOpcionales.find(campo => campo.orden === "CAMPO0").nombreCampo)}</th>
                                                            <td className="details_td_16">{fecha0.toLocaleString()}</td>
                                                        </tr>
                                                    )}

                                                    {camposOpcionales.map((campo) => {
                                                        const index = campo.orden.slice(5); // Extrae el número del orden
                                                        if (campo.orden === "CAMPO0") return null; // Evita duplicar campo0

                                                        return campo.mostrar === "true" && (
                                                            <tr key={`campo${index}`}>
                                                                <th className="details_th_16">{i18n.t(campo.nombreCampo)}</th>
                                                                <td className="details_td_16">{userNft[`campo${index}`]}</td>
                                                            </tr>
                                                        );
                                                    })}

                                                </tbody>
                                            </table>
                                       </div>
                                      )}
                             {pestaniaDetails === 2 && (
                                    modificaciones != null && modificaciones.length > 0 ? (
                                        <div className="certificateProductData_card_1">
                                        <p className="titleCard_16">{i18n.t('ProductDetails')}</p>
                                        <table className="productDetails_table_16">
                                            <thead>
                                            <tr>
                                                <th className="details_th_16">{i18n.t("Foto")}</th>
                                                <th className="details_th_16">{i18n.t("description")}</th>
                                                <th className="details_th_16">{i18n.t("Precio")}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {modificaciones.map((modificacion, index) => (
                                                <tr key={index}>
                                                <td className="details_td_16_mod">
                                                    {modificacion.foto ? (
                                                    <img
                                                        src={modificacion.foto}
                                                        alt={i18n.t("Imagen de modificación")}
                                                        width="200"
                                                        height="200"
                                                    />
                                                    ) : (
                                                    "-"
                                                    )}
                                                </td>
                                                <td className="details_td_16_mod">{modificacion.descripcion || "-"}</td>
                                                <td className="details_td_16_mod">{modificacion.precio ? `$${modificacion.precio}` : "-"}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        <div className="button-container">   
                                          {agregarModificacion !== "no" && (
                                            <div className="button-container">
                                              <button
                                                type="submit"
                                                className="cewy_homePage_emailBtn"
                                                onClick={() => abrirModal()}
                                              >
                                                {i18n.t("aniadirModificacion")}
                                              </button>
                                            </div>
                                          )}</div>
                                        </div>
                                    ) : (
                                        <>
                                        <div className="certificateProductData_card_1">{i18n.t("noModifications")}
                                          
                                        <div className="button-container">
                                          {agregarModificacion !== "false" && (
                                            <div className="button-container">
                                              <button
                                                type="submit"
                                                className="cewy_homePage_emailBtn"
                                                onClick={() => abrirModal()}
                                              >
                                                {i18n.t("aniadirModificacion")}
                                              </button>
                                            </div>
                                          )}</div>
                                        </div>
                                        
                                        
                                        </>
                                    )
                                    )}
                                    {modalAbierto && (
                                       <div className="cewy-modal-overlay">
                                       <div className="cewy-modal-content">
                                         <button className="cewy-modal-close" onClick={cerrarModal}>✖</button>
                                         <h2>{i18n.t("aniadirModificacion")}</h2>
                                     
                                         <div className="cewy-modal-body">
                                           <div className="cewy-input-columns">
                                             <div className="cewy-column">
                                               {camposOpcionales
                                                 .filter((campo) => campo.mostrar === "true" && parseInt(campo.orden.replace("CAMPO", "")) < 8)
                                                 .map((campo) => {
                                                   const index = parseInt(campo.orden.replace("CAMPO", ""));
                                                   return (
                                                     <div key={`campo${index}`} className="cewy-form-group">
                                                       <label className="cewy-label">{i18n.t(campo.nombreCampo)}</label>
                                                       <input
                                                         type="text"
                                                         value={valores[`campo${index}`] ?? ""}
                                                         onChange={(e) => manejarCambio(index, e.target.value)}
                                                         className="cewy-input"
                                                       />
                                                     </div>
                                                   );
                                                 })}
                                             </div>
                                     
                                             <div className="cewy-column">
                                               {camposOpcionales
                                                 .filter((campo) => campo.mostrar === "true" && parseInt(campo.orden.replace("CAMPO", "")) >= 8)
                                                 .map((campo) => {
                                                   const index = parseInt(campo.orden.replace("CAMPO", ""));
                                                   return (
                                                     <div key={`campo${index}`} className="cewy-form-group">
                                                       <label className="cewy-label">{i18n.t(campo.nombreCampo)}</label>
                                                       <input
                                                         type="text"
                                                         value={valores[`campo${index}`] ?? ""}
                                                         onChange={(e) => manejarCambio(index, e.target.value)}
                                                         className="cewy-input"
                                                       />
                                                     </div>
                                                   );
                                                 })}
                                             </div>
                                           </div>
                                     
                                           <div className="cewy-modal-form">
                                             <label className="cewy-label">{i18n.t("Foto")}</label>
                                             <input type="file" className="cewy-input-file" onChange={manejarCambioFoto} />
                                     
                                             <label className="cewy-label">{i18n.t("Descripcion")}</label>
                                             <textarea className="cewy-textarea-adjustable" onChange={manejarCambioDescripcion}></textarea>
                                     
                                             <label className="cewy-label">{i18n.t("Precio")}</label>
                                             <input type="text" className="cewy-input" onChange={manejarCambioPrecio} />
                                     
                                             <button className="cewy-modal-button" onClick={enviarModificacion}>{i18n.t("Guardar")}</button>
                                           </div>
                                         </div>
                                       </div>
                                     </div>
                                     
                                      )}


  
  
  
        </>
      );

};

export default ProductDetailsComponent;
